import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import VerbHeading from '../../../shared/components/VerbHeading';
import { IMAGE_PROPS } from '../../../shared/utils/ImageUtils';
import Image from '../../../shared/components/Image';
import { calculatePercentage } from '../../../shared/utils/NumberUtils';

export default class CollectionContainer extends PureComponent {
    static propTypes = {
        userCollection: PropTypes.object,
        collection: PropTypes.object,
        currentUserPathway: PropTypes.object,
        totalCollectionAssets: PropTypes.number,
        totalCollectionAssetsComplete: PropTypes.number,
        hideCollectionProgress: PropTypes.bool
    };

    render() {
        const {
            collection = {},
            userCollection = {},
            totalCollectionAssets = 0,
            totalCollectionAssetsComplete = 0,
            currentUserPathway = {},
            hideCollectionProgress = false
        } = this.props;

        const cloudinaryImageProps = IMAGE_PROPS.collectionImageCloudinary;
        if (isEmpty(collection)) {
            return null;
        }
        const progress =
            !isEmpty(currentUserPathway) && calculatePercentage(totalCollectionAssetsComplete, totalCollectionAssets);

        return (
            <div className={'row collection-section'}>
                <div className={'container path-container justify-content-center'}>
                    <VerbHeading
                        className={'col-12 d-flex justify-content-center'}
                        messageId={'ABOUT_THIS_COLLECTION'}
                        hNumber={5}
                        defaultMessage={'ABOUT THIS PATH'}
                    />
                    <div className='col-12'>
                        <div className={'row collection-data-container'}>
                            <div className={'col-auto collection-thumbnail-image'}>
                                <Link to={`/collection/${collection.permalink || collection._id}`}>
                                    <Image
                                        className={'collection-thumbnail'}
                                        src={collection.thumbnailImageUrl}
                                        cloudinaryCrop={cloudinaryImageProps.cloudinaryCrop}
                                        dimension={{ w: 256, h: 256 }}
                                    />
                                </Link>
                            </div>
                            <div className={'col collection-metadata-container'}>
                                <Link to={`/collection/${collection.permalink || collection._id}`}>
                                    <h4>{collection.name}</h4>
                                </Link>
                                <div
                                    className={cns('collection-progress-bar-container', {
                                        hidden: !progress || hideCollectionProgress
                                    })}
                                >
                                    <VerbHeading
                                        className={'progress-bar-label'}
                                        messageId={'ASSET_INTERSTITIAL_COLLECTION_PROGRESS_TEXT'}
                                        hNumber={6}
                                        defaultMessage={'COLLECTION PROGRESS'}
                                    />
                                    <ProgressBar now={progress} />
                                </div>
                                <p className={'collection-subtitle'}>{collection.subtitle}</p>
                                <div
                                    className={cns('asset-metadata-container collection-behaviors')}
                                    hidden={!userCollection.totalComplete}
                                >
                                    <h6 className={'asset-category-display asset-primary-behavior'}>
                                        {userCollection.totalComplete} OF {userCollection.totalContent} ACTIVITIES
                                        COMPLETE
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
